import creditCard from '../constants/credit-card';

app.constant('creditCard', {
  CARD_LIST_LIMIT: creditCard.CARD_LIST_LIMIT,
  BRAND_ICON_MAP: creditCard.BRAND_ICON_MAP,
});
